import { apiGet, apiPost } from './client';

export type MfaStatus = {
  enabled: boolean;
  enrolledAt: string | null;
  lastUsedAt: string | null;
  backupCodesRemaining: number;
};

export type MfaEnrollInit = {
  secret: string;
  otpauthUri: string;
  qrDataUrl: string;
  issuer: string;
  label: string;
};

export type MfaEnrollVerify = {
  enabled: boolean;
  backupCodes: string[];
  backupCodesNote: string;
};

export const mfaApi = {
  status: () => apiGet<MfaStatus>('/api/auth/mfa/status'),
  enrollInit: () => apiPost<MfaEnrollInit>('/api/auth/mfa/enroll-init', {}),
  enrollVerify: (code: string) =>
    apiPost<MfaEnrollVerify>('/api/auth/mfa/enroll-verify', { code }),
  disable: (password: string, code: string) =>
    apiPost<{ enabled: boolean }>('/api/auth/mfa/disable', { password, code }),
  /** Admin: reset another user's MFA. Requires `users.mfa.reset` permission. */
  adminReset: (userId: number) =>
    apiPost<{ ok: true; userId: number; mfaEnabled: false }>(
      `/api/users/${userId}/mfa/reset`,
      {},
    ),
};
